import { render } from "./account_actions.vue?vue&type=template&id=2d1f537d"
import script from "./account_actions.js?vue&type=script&lang=js"
export * from "./account_actions.js?vue&type=script&lang=js"

import "./account_actions.vue?vue&type=style&index=0&id=2d1f537d&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__